const localePt = {
  // Degree card
  UDE_GO_TO_DEGREE_LIST: 'Ver todos mis MicroDegree',
  UDE_DEGREE_START_DATE: 'Inicio de clases: {{date}}',
  UDE_DEGREE_FINAL_PROJECT_START: 'Inicio de proyecto final: {{date}}',
  UDE_DEGREE_FINAL_PROJECT_DEADLINE: 'Entrega de proyecto final: {{date}}',
  UDE_DEGREE_COMPLETED_SHORT: 'MicroDegree completado',
  UDE_DEGREE_COMPLETED:
    '¡Felicitaciones! Has completado con éxito tu Microdegree.',
  UDE_BOOTCAMP_COMPLETED:
    '¡Felicitaciones! Has completado con éxito tu Bootcamp.',
  UDE_DOWNLOAD_DIPLOMA: 'Descargar diploma',
  UDE_DOWNLOAD_CERTIFICATE: 'Descargar certificado',
  UDE_DOWNLOAD_PARTICIPATION_CERTIFICATE: 'Descargar constancia',
  UDE_COMPLETED_COURSES: 'Cursos completados del MicroDegree',
  UDE_TOTAL_ATTENDENCE: 'Asistencias totales',
  UDE_CHAT_WITH_OTHER_STUDENTS: 'Interactua con otros estudiantes del Bootcamp',
  UDE_TOTAL_APPROVED_PROJECTS: 'Total de proyectos aprobados',
  UDE_REQUIRED_APPROVED_PROJECTS: 'Proyectos parciales aprobados',
  UDE_OPTIONAL_APPROVED_PROJECTS: 'Proyectos opcionales aprobados',
  UDE_DEGREE_ATTACHMENTS_TITLE:
    'Resuelve tus dudas con nuestras guías del MicroDegree',
  UDE_DEGREE_ATTACHMENTS_LINK: 'Descargar guías',
  UDE_DEGREE_ATTACHMENTS_DIALOG_TITLE: 'Descarga aquí las guías de apoyo',
  UDE_DEGREE_UNAVAILABLE_LINK: 'Próximamente',
  UDE_DEGREE_ROADMAP_TITLE: 'Esquema del MicroDegree',
  UDE_PENDING_PROJECTS: '{{count}} proyecto pendiente',
  UDE_PENDING_PROJECTS_plural: '{{count}} proyectos pendientes',
  UDE_MODULE_WORKBOOK_BOOTCAMP: 'Workbook - {{module}}',
  UDE_DOWNLOAD_WORKBOOK: 'Descargar workbook',
  UDE_REQUIRED_PROJECTS_ALERT:
    'Para empezar tu proyecto final, debes haber completado los {{total}} proyectos parciales de tu MicroDegree.',
  // Course item
  UDE_COURSE_LABEL: 'Curso {{order}}',
  UDE_COURSE_MODULES: '{{modules}} módulos',
  UDE_DOWNLOAD_COURSE_ATTACHMENTS: 'Descargar adjuntos del curso',
  UDE_ENABLED_AT: 'Disponible {{date}}',
  // Project item
  UDE_REQUIRED_PROJECT_LABEL: 'Proyecto Parcial #{{order}}',
  UDE_REQUIRED_PROJECT_DESC:
    'Completar este proyecto **es obligatorio** para la entrega de tu proyecto final.',
  UDE_OPTIONAL_PROJECT_LABEL: 'Proyecto opcional #{{order}}',
  UDE_OPTIONAL_PROJECT_DESC:
    'Completar este proyecto **es opcional** para la entrega de tu proyecto final.',
  UDE_FINAL_PROJECT_LABEL: 'Proyecto Final',
  UDE_FINAL_PROJECT_DESC:
    'Para empezar tu proyecto final, **debes haber aprobado todos los proyectos parciales de tu MicroDegree**.',
  UDE_EMPTY_PROJECT_TITLE: 'Proyecto sin título',
  UDE_PROJECT_START: 'Inicio {{date}}',
  UDE_PROJECT_DEADLINE: 'Entrega {{date}}',
  UDE_FINAL_PROJECT_EXPIRED:
    'La subida de proyecto ya no se encuentra disponible',
  // Event item
  UDE_SCHEDULE_EVENT: 'Agregar a calendario',
  UDE_SCHEDULE_EVENT_AGAIN: 'Agendar nuevamente',
  UDE_GO_TO_COMPLEMENTARY_SESSION: 'Ir a la sesión',
  UDE_GO_TO_EXTERNAL_SESSION: 'Ir al zoom',
  UDE_GO_TO_COUNSELLING: 'Ir a la asesoría',
  UDE_GO_TO_KICKOFF: 'Ir al onboarding',
  UDE_WATCH_COMPLEMENTARY_SESSION: 'Ver sesión grabada',
  UDE_GO_TO_CLASS_MATERIAL: 'Ver material de clase',
  UDE_WATCH_COUNSELLING: 'Ver asesoría grabada',
  UDE_WATCH_KICKOFF: 'Ver onboarding grabado',
  UDE_OPEN_DISCORD: 'Abrir discord',
  // Error view
  UDE_DEGREE_ERROR: 'Ocurrió un error al obtener tu microdegree',
};

export default localePt;
